import React, { useState } from 'react';
import { ListListsCategories } from './ListListsCategories.js';
import { AddListCategory } from './AddListCategory.js';
import { ListButton, AddButton, FAB } from '../../shared/ActionButtons';

export const ListsCategoriesActions = ({ screen, setScreen }) => (
  <div className="action-buttons">
    <ListButton isActive={screen === 'list'} onClick={() => setScreen('list')} />
    <AddButton  isActive={screen === 'add'}  onClick={() => setScreen('add')}  />
  </div>
);

const ListsCategories = ({ screen, setScreen, actions }) => {
  const [localScreen, setLocalScreen] = useState('list');
  const currentScreen    = screen    !== undefined ? screen    : localScreen;
  const setCurrentScreen = setScreen !== undefined ? setScreen : setLocalScreen;

  return (
    <>
      {actions && <div className="content-header">{actions}</div>}
      {currentScreen === 'list' && <ListListsCategories />}
      {currentScreen === 'list' && <FAB onClick={() => setCurrentScreen('add')} />}
      {currentScreen === 'add'  && (
        <AddListCategory onSuccess={() => setCurrentScreen('list')} />
      )}
    </>
  );
};

export default ListsCategories;
